// extracted by mini-css-extract-plugin
export default {"exploreByCategoryHeader":"DealShop_exploreByCategoryHeader__2Nu4R","categoryHeaderTitle":"DealShop_categoryHeaderTitle__ZBUod"};